<div class="card form-right">
  <div class="back">
    <h2>{{ (edit ? "settings.mail.templates.edit" : "settings.mail.templates.add") | translate }}</h2>
    <i class="icon-cross2" (click)="emitBack()"></i>
  </div>

  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- Name -->
      <div class="mb-3">
        <label class="form-label">{{ "settings.mail.templates.name" | translate }} *</label>
        <input type="text" class="form-control" formControlName="name"
          [ngClass]="{ 'is-invalid': isFieldInvalid('name') }">
      </div>

      <!-- Subject -->
      <div class="mb-3">
        <label class="form-label">{{ "settings.mail.templates.subject" | translate }}</label>
        <input type="text" class="form-control" formControlName="subject">
      </div>

      <!-- Body HTML -->
      <div class="mb-3">
        <label class="form-label">{{ "settings.mail.templates.body" | translate }}</label>
        <div class="richtext-editor">
          <div class="richtext-toolbar">
            <button type="button" (click)="execCommand('bold')" title="Negrita"><b>B</b></button>
            <button type="button" (click)="execCommand('italic')" title="Cursiva"><i>I</i></button>
            <button type="button" (click)="execCommand('underline')" title="Subrayado"><u>U</u></button>
            <span class="toolbar-separator"></span>
            <button type="button" (click)="execCommand('justifyLeft')" title="Izquierda"><i class="icon-align-left"></i></button>
            <button type="button" (click)="execCommand('justifyCenter')" title="Centro"><i class="icon-align-center"></i></button>
            <button type="button" (click)="execCommand('justifyRight')" title="Derecha"><i class="icon-align-right"></i></button>
            <span class="toolbar-separator"></span>
            <button type="button" (click)="execCommand('insertUnorderedList')" title="Lista">&#8226;</button>
            <button type="button" (click)="insertLink()" title="Link"><i class="icon-link"></i></button>
          </div>
          <div class="richtext-content" contenteditable="true"
            #editorBody
            (input)="onEditorInput($event, 'body_html')"
            (blur)="onEditorInput($event, 'body_html')">
          </div>
        </div>
      </div>

      <!-- Colors -->
      <div class="row">
        <div class="col-6 mb-3">
          <label class="form-label">{{ "settings.mail.templates.primary_color" | translate }}</label>
          <div class="d-flex align-items-center gap-2">
            <input type="color" class="form-control form-control-color" formControlName="primary_color">
            <input type="text" class="form-control" [value]="form.get('primary_color')?.value" (input)="form.get('primary_color')?.setValue($any($event.target).value)" placeholder="#1a4fa0">
          </div>
        </div>
        <div class="col-6 mb-3">
          <label class="form-label">{{ "settings.mail.templates.secondary_color" | translate }}</label>
          <div class="d-flex align-items-center gap-2">
            <input type="color" class="form-control form-control-color" formControlName="secondary_color">
            <input type="text" class="form-control" [value]="form.get('secondary_color')?.value" (input)="form.get('secondary_color')?.setValue($any($event.target).value)" placeholder="#f5a623">
          </div>
        </div>
      </div>

      <!-- Header HTML -->
      <div class="mb-3">
        <label class="form-label">{{ "settings.mail.templates.header" | translate }}</label>
        <div class="richtext-editor richtext-sm">
          <div class="richtext-toolbar">
            <button type="button" (click)="execCommand('bold')" title="Negrita"><b>B</b></button>
            <button type="button" (click)="execCommand('italic')" title="Cursiva"><i>I</i></button>
            <button type="button" (click)="execCommand('underline')" title="Subrayado"><u>U</u></button>
            <button type="button" (click)="insertLink()" title="Link"><i class="icon-link"></i></button>
          </div>
          <div class="richtext-content" contenteditable="true"
            #editorHeader
            (input)="onEditorInput($event, 'header_html')"
            (blur)="onEditorInput($event, 'header_html')">
          </div>
        </div>
      </div>

      <!-- Footer HTML -->
      <div class="mb-3">
        <label class="form-label">{{ "settings.mail.templates.footer" | translate }}</label>
        <div class="richtext-editor richtext-sm">
          <div class="richtext-toolbar">
            <button type="button" (click)="execCommand('bold')" title="Negrita"><b>B</b></button>
            <button type="button" (click)="execCommand('italic')" title="Cursiva"><i>I</i></button>
            <button type="button" (click)="execCommand('underline')" title="Subrayado"><u>U</u></button>
            <button type="button" (click)="insertLink()" title="Link"><i class="icon-link"></i></button>
          </div>
          <div class="richtext-content" contenteditable="true"
            #editorFooter
            (input)="onEditorInput($event, 'footer_html')"
            (blur)="onEditorInput($event, 'footer_html')">
          </div>
        </div>
      </div>

      <!-- Signature HTML -->
      <div class="mb-3">
        <label class="form-label">{{ "settings.mail.templates.signature" | translate }}</label>
        <div class="richtext-editor richtext-sm">
          <div class="richtext-toolbar">
            <button type="button" (click)="execCommand('bold')" title="Negrita"><b>B</b></button>
            <button type="button" (click)="execCommand('italic')" title="Cursiva"><i>I</i></button>
            <button type="button" (click)="execCommand('underline')" title="Subrayado"><u>U</u></button>
            <button type="button" (click)="insertLink()" title="Link"><i class="icon-link"></i></button>
          </div>
          <div class="richtext-content" contenteditable="true"
            #editorSignature
            (input)="onEditorInput($event, 'signature_html')"
            (blur)="onEditorInput($event, 'signature_html')">
          </div>
        </div>
      </div>

      <!-- Roles -->
      <div class="mb-3">
        <label class="form-label">{{ "settings.mail.templates.roles" | translate }}</label>
        <select class="form-control" (change)="addRole($any($event.target).value); $any($event.target).value = ''">
          <option value="" disabled selected>{{ "settings.mail.templates.roles_placeholder" | translate }}</option>
          <option *ngFor="let role of getAvailableRolesFiltered()" [value]="role">{{ role }}</option>
        </select>
        <div class="roles-list" *ngIf="form.get('roles')?.value?.length">
          <div class="role-chip" *ngFor="let role of form.get('roles')?.value">
            <span>{{ role }}</span>
            <i class="icon-cross2 role-remove" (click)="removeRole(role)"></i>
          </div>
        </div>
        <small class="text-muted">{{ "settings.mail.templates.roles_hint" | translate }}</small>
      </div>

      <!-- Submit -->
      <div class="btn-izq">
        <button type="submit" class="btn btn-hover w-100" [disabled]="form.invalid">
          {{ (edit ? "buttons.save" : "buttons.create") | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
